'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import Immutable from 'immutable';
import * as LIST_QUERIES from '../constants/reviews/ReviewsListQueries';
import { cleanObject } from '../utils/formatters';
import { REVIEWS_PER_PAGE } from '../constants/reviews/ReviewsListQueries';
const defaults = {
  offeringId: null,
  profileId: null,
  reviewType: null,
  limit: REVIEWS_PER_PAGE,
  page: 1,
  filter: LIST_QUERIES.FILTER.ALL,
  industry: null,
  employees: null,
  catalogServices: null,
  search: '',
  sort: LIST_QUERIES.SORT.NEWEST
};
export default class ReviewFilters extends Immutable.Record(defaults) {
  static from(data) {
    return new ReviewFilters(data);
  }

  toSearchQuery() {
    const {
      STATE_TO_QUERY
    } = LIST_QUERIES;
    const searchQuery = Object.assign({}, cleanObject(this.toJS()), {}, STATE_TO_QUERY[this.get('filter')], {}, STATE_TO_QUERY[this.get('sort')], {
      offset: this.get('page') * this.get('limit') - this.get('limit')
    });

    if (!this.get('search')) {
      delete searchQuery.search;
    }

    if (this.get('industry')) {
      searchQuery.industries = {
        clause: 'OR',
        values: [this.get('industry')]
      };
    }

    if (this.get('employees')) {
      searchQuery.employeeSizes = {
        clause: 'OR',
        values: [this.get('employees')]
      };
    }

    if (this.get('catalogServices')) {
      searchQuery.catalogServices = {
        clause: 'OR',
        values: [this.get('catalogServices')]
      };
    }

    const trimmedSearchQuery = _objectWithoutPropertiesLoose(searchQuery, ["sort", "filter", "industry", "employees"]);

    return trimmedSearchQuery;
  }

}